// @flow

import type {
  Asset,
} from 'fc-model-assets/types'

import {
  // Seasonal Asset Categories
  FIELD,
  MANAGEMENT_ZONES,
  HARVEST,
  APPLIED,
  PROFIT,
  PREDICTION,
  CROP_HEALTH,

  // Asset Model Properties
  PROP_CATEGORY,
} from '../constants'

export default function isSeasonal (asset: Asset): boolean {
  return [
    FIELD,
    MANAGEMENT_ZONES,
    HARVEST,
    APPLIED,
    PROFIT,
    PREDICTION,
    CROP_HEALTH,
  ].indexOf(asset[PROP_CATEGORY]) >= 0
}
